import { CellContext } from '@tanstack/react-table';

import { EMPTY_CELL_VALUE } from 'shared_DEPRECATED/config/table';

import { ParticipantsTableRowDataType } from 'features/participants/config/types';

import { Typography } from 'shared/components/Typography';

export const ParticipantsTableSprintDurationCell = ({
  getValue,
}: CellContext<ParticipantsTableRowDataType, string>) => {
  const value = getValue();

  return (
    <Typography
      fontWeight="regular"
      whiteSpace="nowrap"
      type="small"
      data-testid="participant-sprint-period"
      color="black"
    >
      {value || EMPTY_CELL_VALUE}
    </Typography>
  );
};
